<template>
  <a class="button-logout no-print" href="/Auth/SSO/DOE_SSO.php?logout">
    Logout
  </a>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
})
export default class ButtonLogout extends Vue {
}
</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/ButtonLogout.vue